import { render, staticRenderFns } from "./QuestionImport.vue?vue&type=template&id=08439bf6&scoped=true&"
import script from "./QuestionImport.vue?vue&type=script&lang=js&"
export * from "./QuestionImport.vue?vue&type=script&lang=js&"
import style0 from "./QuestionImport.vue?vue&type=style&index=0&id=08439bf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08439bf6",
  null
  
)

export default component.exports